export default __webpack_public_path__ + "norrtag-wiki.pdf";